// src/ui/NavRail.jsx — the floating icon bar over the chat list: Chats · Vibes ·
// Calls · Profile. Icons only, by request. It slides away as you travel down the
// list and returns the moment you head back up (Sidebar reports scroll direction).
//
// 🟢 UNREAD BADGES: each icon can carry a count — chats with unread messages,
// missed calls since the Calls screen was last opened, unread Vibes notifications.
// The numbers shrink as things are read (a chat opened, a notification tapped)
// and only vanish when everything is read — same rule the app follows.
import React from 'react';
import { ChatBubble, Phone, Person } from './icons';
/* 🟢 the same record the profile panel paints from, so a reload with no network
   keeps my face on the rail instead of dropping back to the generic glyph */
import { selfAvatarSource } from '../services/selfIdentity';
import { getSelfIdentity } from '../services/selfIdentityWeb';

/** 🟢 VIBES = a smiley, the app's own tab icon (Ionicons happy / happy-outline).
 *  Outline normally, solid once the tab is active — the same pair the phone
 *  swaps between. */
const Smiley = ({ width = 21, height = 21, filled }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} fill="none"
    stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9.2" fill={filled ? 'currentColor' : 'none'} />
    {filled ? (
      <>
        <circle cx="8.9" cy="10" r="1.15" fill="var(--allo-blue)" stroke="none" />
        <circle cx="15.1" cy="10" r="1.15" fill="var(--allo-blue)" stroke="none" />
        <path d="M8 14.2c1.05 1.25 2.4 1.9 4 1.9s2.95-.65 4-1.9"
          stroke="var(--allo-blue)" strokeWidth="1.9" />
      </>
    ) : (
      <>
        <circle cx="8.9" cy="10" r="1.05" fill="currentColor" stroke="none" />
        <circle cx="15.1" cy="10" r="1.05" fill="currentColor" stroke="none" />
        <path d="M8 14.2c1.05 1.25 2.4 1.9 4 1.9s2.95-.65 4-1.9" />
      </>
    )}
  </svg>
);

const ITEMS = [
  { id: 'chats', Icon: ChatBubble, label: 'Chats' },
  { id: 'vibes', Icon: Smiley, label: 'Vibes' },
  { id: 'calls', Icon: Phone, label: 'Calls' },
  { id: 'profile', Icon: Person, label: 'Profile' },
];

export default function NavRail({ view, onPick, hidden, badges, myProfile }) {
  return (
    <nav className={`nav-rail ${hidden ? 'hidden' : ''}`} aria-label="Sections">
      {ITEMS.map(({ id, Icon, label }) => {
        const n = Number(badges?.[id]) || 0;
        return (
          <button
            key={id}
            className={`nav-btn ${view === id ? 'on' : ''}`}
            title={n > 0 ? `${label} · ${n} unread` : label}
            aria-label={label}
            onClick={() => onPick(id)}
          >
            {id === 'profile' && selfAvatarSource(myProfile, null, getSelfIdentity()) ? (
              /* 🟢 my own photo stands in for the generic person glyph, ringed in
                 black so it reads as a button rather than a floating cut-out */
              <img className="nav-me" src={selfAvatarSource(myProfile, null, getSelfIdentity())} alt="" />
            ) : (
              /* 🟥 `filled` IS THE SMILEY'S PROP ALONE. It used to be passed to every
                 icon in the rail, and the others spread their props straight onto
                 the <svg> — so `filled={false}` reached the DOM and React warned
                 about a non-boolean attribute on every render. Only hand it to the
                 icon that actually has a filled state. */
              <Icon width={21} height={21} {...(id === 'vibes' ? { filled: view === 'vibes' } : {})} />
            )}
            {n > 0 && <span className="nav-badge">{n > 99 ? '99+' : n}</span>}
          </button>
        );
      })}
    </nav>
  );
}
